<template>
  <mdb-card class="group-card"
            v-bind:style="'background-image: url(\'' + group.banner + '\'); ' +
             'background-position-x: center; background-size:cover;' +
             ' background-position-y: ' + group.bannerYPosition"
  >
    <mdb-view class="card-image pt-4" hover>
      <router-link :to="{ path: group.homeUrl}">
        <mdb-card-image alt="Card image cap" class="rounded-circle" style="width:100px; border: 2px solid #bac7cd;"
                        v-bind:src="group.avatar"></mdb-card-image>
        <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
      </router-link>
    </mdb-view>
    <mdb-card-body class="group-overlay-container">
      <router-link :to="{ path: group.homeUrl}"
                   class="group-overlay-name">
        {{ group.name }}
      </router-link>
      <div v-if="tenantName">
        <mdb-badge>{{ tenantName }}</mdb-badge>
      </div>
    </mdb-card-body>
    <mdb-card-footer class="mt-2" v-if="addLink">
      <mdb-btn size="sm" rounded @click="click" role="button">{{ addLink }}</mdb-btn>
    </mdb-card-footer>
  </mdb-card>

</template>

<script>
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbIcon,
  mdbMask,
  mdbView
} from 'mdbvue';

export default {
  name: 'group-card',
  components: {
    mdbCard,
    mdbBtn,
    mdbBadge,
    mdbCardHeader,
    mdbCardBody,
    mdbCardImage,
    mdbCardFooter,
    mdbView,
    mdbIcon,
    mdbMask
  },
  props: {
    group: {
      type: Object,
      default: null
    },
    addLink: {
      type: String,
      default: null
    },
    tenantName: {
      type: String,
      default: null
    }
  },
  methods: {
    click: function (e) {
      this.$emit("click")
    }
  }
};
</script>

<style scoped>
.group-card {
  flex: 1 0 30%;
  margin-bottom: 15px;
}

.card-image {
  margin: auto !important;
}

.group-overlay-container {
  background-color: #ffffff;
  opacity: 0.8;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.group-overlay-name {
  font-size: 1.5em;
  opacity: 1;
}

.group-footer {
  background-color: #ffffff;
  opacity: 0.8;
}

</style>
